module.exports = __webpack_public_path__ + "staticVue/media/video1.6a489043.mp4";